import React, {useEffect, useMemo, useRef, useState} from 'react'
import PaperComponent from "../../components/MuiDraggableDialog";
import {
    Alert,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormHelperText,
    List,
    ListItemButton,
    ListItemText,
    Slide,
    Tooltip
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import MDInput from "../../components/MDInput";
import MDBox from "../../components/MDBox";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import {MuiDatePicker} from "../../components/MuiDatePicker";
import Fade from "@mui/material/Fade";
import {MuiDataGrid} from "../../components/MuiDatagrid";
import LocalStorage from "../../utils/LocalStorage";
import {
    GridActionsCellItem,
    GridEditDateCell,
    GridEditInputCell,
    GridRowEditStopReasons,
    GridRowModes,
} from "@mui/x-data-grid";
import {enUS, zhCN} from '@mui/x-data-grid/locales';
import {Logout, onErrorAlert, onSuccessAlert} from "../../actions";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import {InventoryActionType, kitProduct, ownerSelected} from "../../actions/inventory/inventoryAction";
import {noop} from "lodash";
import {v4 as uuidv4} from 'uuid';
import MDButton from "../../components/MDButton";
import Button from "@mui/material/Button";
import {
    ASNInfo,
    cancelASN, check_inbound_from_order_no,
    createASN,
    customer_choice, editAndSubmitASN,
    editASN,
    inbound_warehouse_List,
    InboundsActionType,
    inboundsFilter,
    inboundWithdraw, saveAndSubmitASN, saveAndSubmitInboundASN
} from "../../actions/inbounds/inboundsAction";
import Card from "@mui/material/Card";
import MDTypography from "../../components/MDTypography";
import {hasEditMode, UnitArray} from "../../utils/globalFunction";
import {useDebounce} from "use-debounce";
import InboundDetail from "./InboundDetail";
import InboundProductDetail from "./InboundProductDetail";
import CarriersInformation from "./CarriersInformation";
import OperationInfo from "./OperationInfo";
import PublishIcon from '@mui/icons-material/Publish';
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import {LoadingButton} from "@mui/lab";
import CircularProgress from "@mui/material/CircularProgress";
import {getInboundOrderStatusArr} from "../../constants";
import TextField from "@mui/material/TextField";
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import {createAndSaveOutBoundsWarehouse, createOutBoundsWarehouse} from "../../actions/outbounds/outboundsAction";
import {check_customer_id} from "../../actions/customer/customerAction";


const InboundsEditor = ({ isOpen, setIsOpen, type = 'Add', setType, data = {}, pageFormData = {}, pageLoading, setPageLoading, setCurrentRow, changeASNStatus, setIsPrintOpen, setTransferData ,setTotal,setList
                            ,setIsSubmitAlertOpen,
                            isSubmitAlertOpen,
                            setPreviewData,
                            previewData,
                            deleteOpen,
                            setDeleteOpen,
                            setOwnerId,
                            ownerId,
                            setSelectedRowDataMap,
                            setRowSelection
}) => {

    const { t } = useTranslation()
    const timeoutRef = useRef(null);
    const businessTypeArr = [
        {
            id: 1,
            value: "WHOLESALE_ASN",
            label: `${t(`Sidebar.Wholesale`)}`
        },
    ]

    const ASNArr = getInboundOrderStatusArr(t);

    const invalidPackMsg = `${t("ReturnsPage.Products with Invalid Packaging Configuration, please reconfigure it in product page")}`
    const validPackMsg = `${t("ReturnsPage.Products with Valid Packaging Configuration")}`
    const darkMode = useSelector(state => state?.common?.darkMode,(prev, next) => prev === next)
    const dispatch = useDispatch()
    const nav = useNavigate()
    const [loading, setLoading] = useState(false)
    const [loadCustomer, setLoadCustomer] = useState(false)
    const [loadingButtonState,setLoadingButtonState] = useState(false)
    const [loadingType,setLoadingType] = useState(null)
    const [closeWarning, setCloseWarning] = useState(false)
    const [businessType, setBusinessType] = useState(businessTypeArr[0])
    const [date, setDate] = useState(null)
    const [rowDate, setRowDate] = useState(null)
    const [warehouse, setWarehouse] = useState(null)
    const [warehouseInput, setWarehouseInput] = useState('');
    const [ownerList ,setOwnerList] =useState([])
    const [inputOwnerValue,setInputOwnerValue] = useState()
    const [ownerValue] = useDebounce(inputOwnerValue, 500);
    const [ASN, setASN] = useState(ASNArr[0])
    const warehouseList = useSelector(state => state?.inventory?.warehouseList,(prev, next) => prev === next)
    const warehouseListOwner = useSelector(state => state?.outbounds?.warehouseListOwner,(prev, next) => prev === next)
    const kitProductList = useSelector( state => state?.inventory?.kitProductList).map(product => {
        const groupMessage = product.wrongFlag
            ? invalidPackMsg
            : validPackMsg;

        return {
            ...product,
            groupMessage
        };
    },(prev, next) => prev === next);
    const customerList = useSelector(state => state?.inbounds?.customerList,(prev, next) => prev === next)
    const [show, setShow] = useState(false)
    const [rows, setRows] = useState([])
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [selectedPackage, setPackage] = useState(null)
    const [selectedCustomer, setSelectedCustomer] = useState(null)
    const [custShow, setCustShow] = useState(false)
    const [inputValue, setInputValue] = useState('')
    const [inputValueDebounce] = useDebounce(inputValue, 500)
    const [inputProductValue, setInputProductValue] = useState('')
    const [inputProductValueDebounce] = useDebounce(inputProductValue, 500)
    const [isAlertOpen, setIsAlertOpen] = useState(false)
    const [currentDeletedObject, setCurrentDeletedObject] = useState(null)

    const [isWithdrawAlertOpen, setIsWithdrawAlertOpen] = useState(false)
    const [isPrintAlertOpen, setIsPrintAlertOpen] = useState(false)
    const [isAddressOpen,setIsAddressOpen] = useState(false)


    // const [previewData, setPreviewData] = useState({})
    // const [isSubmitAlertOpen, setIsSubmitAlertOpen] = useState(false)
    // const [ownerId, setOwnerId] = useState(null)
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false)
    const [cancelReason, setCancelReason] = useState("")
    const [cancelReasonToSubmit, setCancelReasonToSubmit] = useState(null)
    const [deleteLoading, setDeleteLoading] = useState(false)

    //warehouse filter
    const [inboundWarehouseList,setInboundWarehouseList] = useState([])
    const [warehouseDialogOpen, setWarehouseDialogOpen] = useState(false);
    const [selectedInDialog, setSelectedInDialog] = useState(null);
    const [provinceOption, setProvinceOption] = useState([]);
    const [search, setSearch] = useState('');
    const [warehouseCity, setWarehouseCity] = useState('');
    const [warehousePostcode, setWarehousePostcode] = useState('');
    const [warehouseCountry, setWarehouseCountry] = useState('');
    const [warehouseProvince, setWarehouseProvince] = useState('');
    const [filteredWarehouseList,setFilteredWarehouseList] = useState([]);

    const handleClose = () => {
        setDeleteOpen(false);
    };



    const onRerender = (datax) => {
        setRowSelection({});
        setSelectedRowDataMap({});
        setTotal(datax?.total ? datax?.total:0)
        setList(datax?.rows ? datax?.rows.map((item, index) => {
            return { ...item, id: uuidv4() };
        }):[])
        setPageLoading(false)
    }


    const schema = yup
        .object({
            orderNo: yup.string(),
            fromOrderNo: yup
                .string()
                .transform((value) => (value === '' ? undefined : value))
                // .nullable()
                // .notRequired()
                .required(t('Required'))
                .matches(
                    /^[A-Za-z0-9_.\-\/#*(),]+$/,
                    t('InboundPage.From Order No. can only contain letters and numbers')
                )
        })
    const {
        register,
        reset,
        trigger,
        setError,
        handleSubmit,
        getValues,
        setValue,
        clearErrors,
        watch,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    useEffect(() => {
        const axiosPost = async () => {
            let data = {}
            data.userName = LocalStorage.getItem('username')
            data.ownerId = LocalStorage.getItem('ownerId')
            data.sku = ''
            await dispatch(inbound_warehouse_List((data)=>{setInboundWarehouseList(data?.filter((ele)=>ele.activeFlag !== "N"))}, onError))
            !checkPermission(PERMISSION_DICT.QueryOwnerInfo) && await dispatch(kitProduct(data, noop, onError))
            !checkPermission(PERMISSION_DICT.QueryOwnerInfo) && await dispatch(customer_choice({ condition: '', userName: LocalStorage.getItem('username') ,ownerId: LocalStorage.getItem('ownerId')}, noop, noop))
        }
        axiosPost().then()
    }, [])

    useEffect(() => {
        if(checkPermission(PERMISSION_DICT.QueryOwnerInfo) && ownerId?.ownerName) {
            dispatch({
                type:InboundsActionType.CUSTOMER_LIST,
                payload:[]
            })
            const axiosPost = async () => {
                let data = {}
                data.userName = ownerId?.ownerName
                data.ownerId = ownerId?.ownerId
                data.sku = ''
                await dispatch(kitProduct(data, noop, onError))
                setLoadCustomer(true)
                await dispatch(customer_choice({condition: '', userName: ownerId?.ownerName, ownerId: ownerId?.ownerId}, ()=>{setLoadCustomer(false)}, onError))
            }
            axiosPost().then()

        }
    }, [ownerId])


    // useEffect(() => {
    //     if (type === 'Edit' || type === 'Copy') {
    //         //customer
    //         // const axiosPost = async () => {
    //         //     let formData = {}
    //         //     formData.ownerId = data?.ownerId
    //         //     formData.applyAsnNo = data?.applyAsnNo
    //         //     formData.userName = data?.ownerName
    //         //     setLoading(true)
    //         //     await dispatch(ASNInfo(formData, onInfoSuccess, onError))
    //         // }
    //         // axiosPost().then()
    //         const cust = customerList.filter(v => v.customerId === previewData?.warehousing?.customerId).find(
    //             cust => Number(cust.addressId) === previewData?.warehousing?.customerAddressId
    //         )
    //
    //         setSelectedCustomer(cust)
    //         setCustShow(true)
    //     }
    // }, [customerList])
    
    useEffect(()=>{


        if(ownerValue){
            const axiosPost = async () => {
                await dispatch(ownerSelected({condition: ownerValue, userName: LocalStorage.getItem('username')}, (data)=>setOwnerList(data)))
            }
            axiosPost().then()
        } else {
            setOwnerList([])
        }
    },[ownerValue])


    const fromOrderNoInput = watch('fromOrderNo')
    const [valueFromOrderNo] = useDebounce(fromOrderNoInput, 500);
    const [fromOrderNoError,setFromOrderNoError]= useState(false)

    const onFromOrderNoCheckSuccess = (flag) => {
        if (!flag && type!=='Edit') {
            setFromOrderNoError(true)
            setError("fromOrderNo", {type: "fromOrderNo", message: t('From Order No. existed, please change another one')})
        }
        else {
            setFromOrderNoError(false)
            clearErrors('fromOrderNo')
        }
    }


    useEffect(() => {
        if(checkPermission(PERMISSION_DICT.QueryOwnerInfo) && type !== 'Preview'){
            clearErrors('owner')
            if(ownerId && valueFromOrderNo !=='' && valueFromOrderNo !== null && valueFromOrderNo !== undefined) {
                const axiosPost = async () => {

                    await dispatch(check_inbound_from_order_no({
                        fromOrderNo: valueFromOrderNo,
                        ownerId: ownerId?.ownerId
                    }, onFromOrderNoCheckSuccess,onError))
                }
                axiosPost().then()
            } else {
                // setCustomerId('')
                // clearErrors('sku')
            }
        }

        if(!checkPermission(PERMISSION_DICT.QueryOwnerInfo) && type !== 'Preview'){
            clearErrors('owner')
            if(valueFromOrderNo !=='' && valueFromOrderNo !== null && valueFromOrderNo !== undefined) {
                const axiosPost = async () => {

                    await dispatch(check_inbound_from_order_no({
                        fromOrderNo: valueFromOrderNo,
                        ownerId: LocalStorage.getItem('ownerId'),
                    }, onFromOrderNoCheckSuccess,onError))
                }
                axiosPost().then()
            } else {
                // setCustomerId('')
                // clearErrors('sku')
            }
        }
    },[valueFromOrderNo,ownerId])



    const onCreateSuccess = async (msg) => {

        setIsOpen(false)
        dispatch(onSuccessAlert(t(msg)))

        let formData = {}
        if (pageFormData) {
            formData = pageFormData
        } else {
            return nav('/')
        }

        setPageLoading(true)

        await dispatch(inboundsFilter(formData, onRerender, onError))
    }

    const onError = (msg, code) => {
        dispatch(onErrorAlert(t(msg)))
        setLoadCustomer(false)
        setLoadingButtonState(false)
        setLoading(false)
        setPageLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const onSubmit = (xdata,event) => {
        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo) && !ownerId) {
            dispatch(onErrorAlert(t('InboundPage.Owner ID is required')))
            return setError('owner', { type: 'owner', message: t('Required') })
        }

        if (fromOrderNoError) {
            dispatch(onErrorAlert(t('From Order No. existed, please change another one')))
            return setError("fromOrderNo", {type: "fromOrderNo", message: t('From Order No. existed, please change another one')})
        }

        if (rows?.length === 0) {
            setError('product', { type: 'product', message: t('InboundPage.At least one product must be selected') })
            return dispatch(onErrorAlert(t('InboundPage.At least one product must be selected')))

        } else if (hasEditMode(rowModesModel)) {
            setError('product', { type: 'product', message: t('InboundPage.There any unsaved product records, press the save icon before submitting') })
            return dispatch(onErrorAlert(t('InboundPage.There any unsaved product records, press the save icon before submitting')))

        }


        // let details = []
        // // details = rows
        // details = kitProductList.filter(product => rows.some(row => row.sku === product.sku))
        // details.forEach((v, i) => {
        let detailsList = [...rows]
        let details = detailsList.map((ele,i)=>{
            let result = kitProductList?.find(product => product?.sku === ele?.sku) // 找到注册的sku
            let v = !!result? result: ele
            v.qtyApplyOrdered = rows.find((row) => row?.sku === v?.sku && row?.id === ele.id)?.qty;
            v.qtyExpected = rows.find((row) => row?.sku === v.sku&& row?.id === ele.id).qty;
            v.qtyReceipt = rows.find((row) => row.sku === v.sku&& row?.id === ele.id).qty;
            v.qtySigned = rows.find((row) => row.sku === v.sku&& row?.id === ele.id).qty;
            v.unitQty = rows.find((row) => row.sku === v.sku&& row?.id === ele.id).qty;
            v.grossWeight = v?.packages?.find(object => object?.unit === rows.find((row) => row?.sku === v?.sku&& row?.id === ele.id)?.unit)?.weight
            v.volume = v?.packages?.find(object => object?.unit === rows.find((row) => row?.sku === v.sku&& row?.id === ele.id)?.unit)?.volume
            v.unitConvertRate = v?.packages?.find(object => object?.unit === rows.find((row) => row?.sku === v?.sku&& row?.id === ele.id)?.unit)?.qty
            v.unit = rows.find((row) => row?.sku === v?.sku&& row?.id === ele.id)?.unit;
            v.price = Number(parseFloat(rows.find((row) => row?.sku === v?.sku&& row?.id === ele.id)?.price)?.toFixed(2));
            v.detailTotalPrice = Number(parseFloat(v?.price * v?.unitQty).toFixed(2))
            // if (rows.find((row) => row.sku === v.sku)?.batch !== null && rows.find((row) => row.sku === v.sku&& row?.id === ele.id)?.batch !== '') {
                v.batchNo = rows.find((row) => row.sku === v.sku&& row?.id === ele.id)?.batch
            // }


            const skuRow = rows.find((row) => row.sku === v.sku&& row?.id === ele.id);

            if (skuRow && skuRow.expirationDate) {
                v = {
                    ...v,
                    expirationDate: new Date(skuRow.expirationDate).valueOf(), // 转换为时间戳
                };
            } else {
                v = {
                    ...v,
                    expirationDate: null,
                };
            }

            if (skuRow && skuRow.productionDate) {
                v = {
                    ...v,
                    productionDate: new Date(skuRow.productionDate).valueOf(), // 转换为时间戳
                };
            } else {
                v = {
                    ...v,
                    productionDate: null,
                };
            }

            // if ((rows.find((row) => row.sku === v.sku)?.expirationDate) !== null) {
            //     v.expirationDate = moment(rows.find((row) => row.sku === v.sku)?.expirationDate).valueOf()
            // } else {
            //     v.expirationDate = null
            // }

            // if ((rows.find((row) => row.sku === v.sku)?.productionDate) !== null) {
            //     v.productionDate = moment(rows.find((row) => row.sku === v.sku)?.productionDate).valueOf()
            // } else {
            //     v.productionDate = null
            // }
            // delete v?.id
            delete v?.weight
            return v
        })


        if (warehouse === null) {
            dispatch(onErrorAlert(t('InboundPage.Warehouse is required')))
            return setError('warehouse', { type: 'warehouse', message: t('Required') })
        }

        if (businessType === null) {
            dispatch(onErrorAlert(t('InboundPage.Business Type is required')))
            return setError('businessType', { type: 'businessType', message: t('Required') })
        }

        //开始saveInbound
        if (date === null) {

            dispatch(onErrorAlert(t('InboundPage.Expected Arrival Time is required')))
            return setError('date', { type: 'date', message: t('Required') })
        }
        if(date.isoWeekday() === 6 || date.isoWeekday() === 7){
            dispatch(onErrorAlert(t('InboundPage.Expected Arrival Time should be weekday')))
            return setError('date', { type: 'date', message: t('InboundPage.Expected Arrival Time should be weekday') })
        }

        const today = moment().startOf('day'); // 获取今天的开始时间
        if (date.isBefore(today, 'day')) {
            dispatch(onErrorAlert(t('InboundPage.Expected Arrival Time should not be earlier than today.')))
            return setError('date', { type: 'date', message: t('InboundPage.Invalid Date') })
        }

        if (selectedCustomer === null) {
            dispatch(onErrorAlert(t('InboundPage.Customer is required')))
            return setError('customer', { type: 'customer', message: t('Required') })
        }



        //开始formdata
        let formData = {}
        formData.userName = LocalStorage.getItem('username')

        if (type === 'Add' || type === 'Copy') {
            formData.saveInbound = {}
            formData.saveInbound.asnCreationTime = moment().valueOf()
            formData.saveInbound.asnState = ASNArr[0]?.value
            formData.saveInbound.businessType = businessTypeArr[0]?.value
            formData.saveInbound.carrierId = xdata.carrierId
            formData.saveInbound.carrierOrderNo = xdata.carrierOrderNo
            formData.saveInbound.expectedShipmentTime = date.valueOf()
            formData.saveInbound.fromOrderNo = xdata.fromOrderNo
            formData.saveInbound.totalPrice = details.reduce((accumulator, currentValue) => {
                return accumulator + currentValue?.detailTotalPrice;
            }, 0)
            formData.saveInbound.totalQuantity = details.reduce((accumulator, currentValue) => {
                return accumulator + currentValue?.unitQty;
            }, 0)

            formData.saveInbound.warehouseId = warehouse?.dictValue
            formData.saveInbound.userName = LocalStorage.getItem('username')
            formData.saveInbound.customerAddress = selectedCustomer?.address
            formData.saveInbound.customerAddress2 = selectedCustomer?.address2
            formData.saveInbound.customerAddressId = selectedCustomer?.addressId
            formData.saveInbound.customerCity = selectedCustomer?.city
            formData.saveInbound.customerContact = selectedCustomer?.contact
            formData.saveInbound.customerCountry = selectedCustomer?.country
            formData.saveInbound.customerId = selectedCustomer?.customerId
            formData.saveInbound.customerInfo = selectedCustomer?.customerId + selectedCustomer?.addressId
            formData.saveInbound.customerName = selectedCustomer?.name
            formData.saveInbound.customerPhone = selectedCustomer?.phone
            formData.saveInbound.customerProvince = selectedCustomer?.province
            formData.saveInbound.customerZipcode = selectedCustomer?.zipcode

            formData.details = [...details]
        }

        if (type === 'Edit') {
            formData.modifyInbound = {}

            // formData.modifyInbound.asnState = ASNArr[0]?.value
            formData.modifyInbound.asnState = previewData?.warehousing?.asnState
            formData.modifyInbound.businessType = businessTypeArr[0]?.value
            formData.modifyInbound.carrierId = xdata.carrierId
            formData.modifyInbound.carrierOrderNo = xdata.carrierOrderNo
            formData.modifyInbound.expectedShipmentTime = date.valueOf()
            formData.modifyInbound.fromOrderNo = xdata.fromOrderNo
            formData.modifyInbound.totalPrice = details.reduce((accumulator, currentValue) => {
                return accumulator + currentValue?.detailTotalPrice;
            }, 0)
            formData.modifyInbound.totalQuantity = details.reduce((accumulator, currentValue) => {
                return accumulator + currentValue?.unitQty;
            }, 0)

            formData.modifyInbound.warehouseId = warehouse?.dictValue
            formData.modifyInbound.userName = LocalStorage.getItem('username')
            formData.modifyInbound.customerAddress = selectedCustomer?.address
            formData.modifyInbound.customerAddressId = selectedCustomer?.addressId
            formData.modifyInbound.customerCity = selectedCustomer?.city
            formData.modifyInbound.customerContact = selectedCustomer?.contact
            formData.modifyInbound.customerCountry = selectedCustomer?.country
            formData.modifyInbound.customerId = selectedCustomer?.customerId
            formData.modifyInbound.customerInfo = selectedCustomer?.customerId + selectedCustomer?.addressId
            formData.modifyInbound.customerName = selectedCustomer?.name
            formData.modifyInbound.customerPhone = selectedCustomer?.phone
            formData.modifyInbound.customerProvince = selectedCustomer?.province
            formData.modifyInbound.customerZipcode = selectedCustomer?.zipcode
            formData.modifyInbound.applyAsnNo = data.applyAsnNo
            formData.details = [...details]

        }


        setLoadingButtonState(true)
        const action = event.nativeEvent.submitter.value;

        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo) && ownerId?.ownerName){
            formData.ownerId = ownerId?.ownerId
        }else {
            formData.ownerId = LocalStorage.getItem('ownerId')
        }

        if (type === 'Add' || type === 'Copy') {
            //admin condition add
            if (checkPermission(PERMISSION_DICT.QueryOwnerInfo) && ownerId?.ownerName){
                formData.saveInbound.userName = ownerId?.ownerName
                formData.userName = ownerId?.ownerName
            }

            const axiosPost = async () => {
                if (action === 'saveOnly') {
                    setLoadingType('saveOnly')
                    await dispatch(createASN(formData, (msg)=>{
                        setLoadingButtonState(false)
                        onCreateSuccess(msg)
                    }, onError))
                }else if (action === 'saveAndSubmit') {
                    setLoadingType('saveAndSubmit')
                    await dispatch(saveAndSubmitInboundASN(formData, (msg)=>{
                        setLoadingButtonState(false)
                        onCreateSuccess(msg)
                    }, onError))
                }

            }

            // const axiosPost = async () => {
            //     await dispatch(createASN(formData, (msg)=>{
            //         setLoadingButtonState(false)
            //         onCreateSuccess(msg)
            //     }, onError))
            // }
            axiosPost().then()
        }

        if (type === 'Edit') {
            if (checkPermission(PERMISSION_DICT.QueryOwnerInfo) && ownerId?.ownerName){
                formData.modifyInbound.userName = ownerId?.ownerName
                formData.userName = ownerId?.ownerName
            }
            const axiosPost = async () => {
                if (action === 'saveOnly') {
                    setLoadingType('saveOnly')
                    await dispatch(editASN(formData, (msg)=>{
                        setLoadingButtonState(false)
                        onCreateSuccess(msg)
                        setIsOpen(false)
                    }, onError))
                }else if (action === 'saveAndSubmit') {
                    setLoadingType('saveAndSubmit')
                    if (checkPermission(PERMISSION_DICT.QueryOwnerInfo) && ownerId?.ownerId){
                        formData.modifyInbound.ownerId = ownerId?.ownerId
                    }
                    await dispatch(editAndSubmitASN(formData, (msg)=>{
                        setLoadingButtonState(false)
                        onCreateSuccess(msg)
                    }, onError))
                }

            }
            axiosPost().then()
        }

    }


    const clearAllFields = () => {
        setLoading(true)
        clearErrors()
        // setType('Add')
        setRows([])
        setRowModesModel((rowModesModel) =>Object.keys(rowModesModel).reduce((acc, key) => {
            const row = rowModesModel[key];
            if (row.mode === GridRowModes.Edit) {
                acc[key] = { ...row, mode: GridRowModes.View, ignoreModifications: true};
            } else {
                acc[key] = row;
            }
            return acc;
        }, {}))
        setShow(false)
        setCustShow(false)
        setSelectedCustomer(null)
        setWarehouse(null)
        setWarehouseInput('')
        setOwnerId(null)
        setPackage(null)
        setDate(null)
        setInputProductValue('')
        setInputValue('')
        reset()
        setFromOrderNoError(false)
        setPreviewData({})

        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            dispatch({
                type:InventoryActionType.SKU_CHOICE_PRODUCT,
                payload:[]
            })
            dispatch({
                type:InboundsActionType.CUSTOMER_LIST,
                payload:[]
            })
        }
    }

    const onInfoSuccess = (currentData) => {


        setPreviewData(currentData)
        // setRows([...currentData.details])
        let arrRow = []
        currentData?.details?.forEach(value => {
            let object = {}
            object.id = uuidv4();
            object.sku = value?.sku
            object.skuAlias = kitProductList.find(v => v.sku === value?.sku)?.skuAlias ? kitProductList.find(v => v.sku === value?.sku)?.skuAlias : value?.skuAlias
            object.productName = kitProductList.find(v => v.sku === value?.sku)?.productName ? kitProductList.find(v => v.sku === value?.sku)?.productName : value?.productName
            object.unit = UnitArray.find(v => v.value === value?.unit)?.value
            object.qty = value?.unitQty
            object.price = Number(value?.price)
            object.batch = value?.batchNo || null
            object.expirationDate = value?.expirationDate ? moment(value?.expirationDate, "YYYY-MM-DD").toDate() : null
            object.productionDate = value?.productionDate ? moment(value?.productionDate, "YYYY-MM-DD").toDate() : null

            arrRow = [...arrRow, object]
        })

        setRows([...arrRow])
        setShow(true)

        //
        setValue('fromOrderNo', currentData.warehousing?.fromOrderNo)
        setDate(moment(currentData?.warehousing.expectedShipmentTime))
        setWarehouse(warehouseList.find(value => value.dictValue === currentData.warehousing?.warehouseId))
        setValue('carrierId', currentData.warehousing?.carrierId)
        setValue('carrierOrderNo', currentData.warehousing?.carrierOrderNo)

        //customer
        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            const axiosPost = async () => {
                await dispatch(ownerSelected({condition: data?.ownerId, userName: LocalStorage.getItem('username')}, async (res) => {
                    if (checkPermission(PERMISSION_DICT.QueryOwnerInfo) && res.length === 1) {
                        setOwnerId(res[0])
                        setLoadCustomer(true)
                        await dispatch(customer_choice({
                            userName: res[0]?.ownerName,
                            ownerId: res[0]?.ownerId
                        }, (custList) => {
                            const findCustomer = custList?.find((ele=>ele.customerId === currentData?.warehousing?.customerId))
                            if (!!findCustomer){
                                setSelectedCustomer({
                                    customerId:findCustomer?.customerId,
                                    contact:findCustomer?.contact,
                                    phone:findCustomer?.phone,
                                    name:findCustomer?.name,
                                    addressId:findCustomer?.addressId,
                                    address:findCustomer?.address,
                                    city:findCustomer?.city,
                                    province:findCustomer?.province,
                                    country:findCustomer?.countryCode,
                                    zipcode:findCustomer?.zipcode,
                                    address2: findCustomer?.address2,
                                })
                            }else {
                                dispatch(onErrorAlert(t("InboundPage.No matching Ship From address was found in the address book. Please select again")))
                                setSelectedCustomer(null)
                            }

                            setLoading(false)
                            setLoadCustomer(false)
                        }, onError))
                    }
                }))
            }
            axiosPost().then()
        }
        else {
            const axiosPost = async () => {
                setLoadCustomer(true)
                await dispatch(customer_choice({
                    userName: LocalStorage.getItem('username'),
                    ownerId: LocalStorage.getItem('ownerId')
                }, (custList) => {
                    const findCustomer = custList?.find((ele=>ele.customerId === currentData?.warehousing?.customerId))
                    if (!!findCustomer){
                        setSelectedCustomer({
                            customerId:findCustomer?.customerId,
                            contact:findCustomer?.contact,
                            phone:findCustomer?.phone,
                            name:findCustomer?.name,
                            addressId:findCustomer?.addressId,
                            address:findCustomer?.address,
                            city:findCustomer?.city,
                            province:findCustomer?.province,
                            country:findCustomer?.countryCode,
                            zipcode:findCustomer?.zipcode,
                            address2: findCustomer?.address2,
                        })
                    }else {
                        dispatch(onErrorAlert(t("InboundPage.No matching Ship From address was found in the address book. Please select again")))
                        setSelectedCustomer(null)
                    }
                    setLoadCustomer(false)
                    setLoading(false)
                }, onError))
            }
            axiosPost().then()
        }

    }

    useEffect(() => {


        if (selectedPackage) {
            handleAddRowClick()
        }
    }, [selectedPackage]);

    useEffect(() => {

        if (rows.length > 0) {
            setShow(true)
        } else {
            setShow(false)
        }
    }, [rows]);

    useEffect(() => {
        if (!selectedCustomer) {
            setCustShow(false)
        } else {
            setCustShow(true)
        }
    }, [selectedCustomer]);

    useEffect(() => {

        if (!isOpen) {
            timeoutRef.current = setTimeout(() => {
                clearAllFields();
            }, 500);
        } else {
            setRows([])
            setRowModesModel({})
        }

        if (type !== 'Add' && isOpen) {

            const axiosPost = async () => {
                let formData = {}
                formData.ownerId = data?.ownerId
                formData.applyAsnNo = data?.applyAsnNo
                formData.userName = data?.ownerName
                setLoading(true)
                await dispatch(ASNInfo(formData, onInfoSuccess, onError))
            }
            axiosPost().then()
        }else {
            clearAllFields()
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };

    }, [isOpen]);


    const handleClickCopy = (textToCopy) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t(`copy failed`)}`))
                });
        }

    };


    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut || params.reason === GridRowEditStopReasons.escapeKeyDown) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleAddRowClick = () => {
        const id = uuidv4();
        let defaultPack = selectedPackage?.packages?.find(obj => obj.isDefault === 'Y')



        setRows((oldRows) => [...oldRows, {
            id,
            price: selectedPackage.productPrice,
            expirationDate: null,
            productionDate: null,
            // qty: 1,
            qty: null,
            batch: null,
            sku: selectedPackage.sku,
            skuAlias: selectedPackage.skuAlias,
            productName: selectedPackage.productName,
            // unit:UnitArray[0]?.value || null
            unit: defaultPack ? UnitArray.find(o => o.value === defaultPack?.unit)?.value : selectedPackage?.packages[0]?.unit,
        }]);
        setRowModesModel((oldModel) => ({
            ...oldModel,
            [id]: { mode: GridRowModes.Edit, fieldToFocus: "qty" },
        }));
    };


    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => () => {

        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });

    };

    const handleDeleteClick = (id) => () => {
        setCurrentDeletedObject(rows.find((row) => row.id === id))
        setIsAlertOpen(true)
    };


    const processRowUpdate = (newRow) => {
        const qty = newRow.qty;

        const hasError =
            qty === null ||
            qty === undefined ||
            typeof qty !== 'number' ||
            qty < 1 ||
            qty % 1 !== 0;

        if (hasError) {
            dispatch(
                onErrorAlert(
                    t('InboundPage.The quantity must be an integer that is equal to or greater than zero.')
                )
            );
            
            throw new Error('InboundPage.The quantity must be an integer that is equal to or greater than zero.');
        }


        const updatedRow = { ...newRow };
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const handleCancelClick = (id) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rows.find((row) => row.id === id);
        if (editedRow?.isNew) {
            setRows(rows.filter((row) => row.id !== id));
        }
    };

    useEffect(() => {

    }, [selectedCustomer])

    const checkDeletable = (previewData) => {
        let statusCode = ['0', '10', '20','60']
        return statusCode.indexOf(previewData?.warehousing?.asnState) !== -1;
    }


    const withdrawInbound = () => {
        const axiosPost = async () => {

            setPageLoading(true)
            let formData = {
                // applyAsnNo:row?.applyAsnNo,
                // userName:LocalStorage.getItem('username')
            }
            // if(checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            //     formData = {...formData,ownerId:row?.ownerId}
            // }
            await dispatch(inboundWithdraw(
                formData, onUpdateSuccess, onError))
        }
        axiosPost().then()
    }

    const onUpdateSuccess = (msg) => {
        dispatch(onSuccessAlert(t(msg)))
        setIsWithdrawAlertOpen(false)
        let formData = {}
        if (pageFormData()) {
            formData = pageFormData()
        } else {
            return nav('/')
        }
        const axiosPost = async () => {

            setLoading(true)
            await dispatch(inboundsFilter(formData, onRerender, onError))
        }
        axiosPost().then()
    }

    const getMinBusinessDate = (days) => {
        let d = moment().startOf('day');
        let added = 0;
        while (added < days) {
            d = d.add(1, 'day');
            // isoWeekday 1～5 表示周一到周五
            if (d.isoWeekday() <= 5) {
                added++;
            }
        }
        return d;
    };

    const handleDeleteSubmit = () => {
        let wordsCount = cancelReason.length
        if (wordsCount >= 5 && wordsCount <= 20) {
            if (/\S/.test(cancelReason)) {
                setCancelReasonToSubmit(cancelReason)
                handleClose()
                setIsDeleteAlertOpen(true)
            }
            else {
                onError(`${t("InboundPage.The reason should not be empty space.")}`)
            }
        } else {
            onError(`${t("InboundPage.The reason should between 5 to 20 characters.")}`)
        }

    };

    const onDeleteSubmit = () => {
        const axiosPost = async () => {
            let formData = {
                executeOrderNo: previewData?.warehousing?.applyAsnNo,
                fromOrderNo: previewData?.warehousing?.fromOrderNo,
                orderType: "asnExecute",
                reason: cancelReasonToSubmit,
                userName: LocalStorage.getItem('username'),
                asnState: previewData?.warehousing?.asnState,
                ownerId: previewData?.warehousing?.ownerId,
                platformCode: ''
            }
            setDeleteLoading(true)
            await dispatch(cancelASN(
                formData,
                onCancelSuccess, (msg)=>{
                    setDeleteLoading(false)
                    onError(msg)
                }))
        }
        axiosPost().then()
    }

    const onCancelSuccess = async (msg) => {
        dispatch(onSuccessAlert(t(msg)))
        setDeleteLoading(false)
        setIsDeleteAlertOpen(false)
        setIsOpen(false)

        let formData = {}
        if (pageFormData) {
            formData = pageFormData
        } else {
            return nav('/')
        }

        setPageLoading(true)

        await dispatch(inboundsFilter(formData, onRerender, noop))
    }

    useEffect(() => {
        if (!isDeleteAlertOpen && !deleteOpen){
            setCancelReason("")
            setCancelReasonToSubmit(null)
        }
    },[isDeleteAlertOpen,deleteOpen])

    const handleOpenWarehouseFilterDialog = () => {
        setWarehouseDialogOpen(true);
        setSearch('');
        setWarehousePostcode('')
        setWarehouseCity('')
        setWarehouseProvince(null)
        setWarehouseCountry('')
    };

    const handleConfirm = () => {
        if (selectedInDialog) setWarehouse(selectedInDialog);
        setWarehouseDialogOpen(false);
    };


    useEffect(() => {
        setWarehouseProvince(null)
        const provinces = Array.from(
            new Set(
                inboundWarehouseList
                    .map((ele) => ({
                        ...ele,
                        ...warehouseList.find((e) => e.dictValue === ele.warehouseId),
                    }))
                    .filter((ele) => ele.countryCode === warehouseCountry)
                    .map((ele) => ele.provinceCode)
            )
        );

        setProvinceOption(provinces);
    }, [warehouseCountry]);

    const defaultFilter = createFilterOptions();
    const [isTyping, setIsTyping] = useState(false);
    const hasPermission = checkPermission(PERMISSION_DICT.QueryOwnerInfo);
// 语义：有权限 || 正在输入 ⇒ 全量；否则按 owner 过滤
    const showAll = isTyping;
    const computedOptions = useMemo(() => {
        const base = showAll
            ? (warehouseList.filter((ele)=>inboundWarehouseList.some((v)=>v.warehouseId === ele.dictValue)) ?? [])
            : (warehouseList.filter((ele)=>inboundWarehouseList.some((v)=>v.warehouseId === ele.dictValue)) ?? []).filter(ele =>
                // warehouseListOwner?.some(v => v.dictValue === ele.dictValue)
                (hasPermission) ? false :  warehouseListOwner?.some(v => v.dictValue === ele.dictValue)
            );
        return [...base, { dictLabel: t('InboundPage.More Options'), isMoreButton: true }];
    }, [showAll, warehouseList, warehouseListOwner, t]);

// 保留并固定 “More Options” 在末尾
    const keepMoreAtEnd = (opts, state) => {
        const more = opts.find(o => o?.isMoreButton);
        const filtered = defaultFilter(opts.filter(o => !o?.isMoreButton), state);
        return more ? [...filtered, more] : filtered;
    };

    //dialog keyboard
    const agreeRef = useRef(null);
    const disagreeRef = useRef(null);

    const handleKeyDown = (e) => {
        if (e.key === 'ArrowLeft') {
            disagreeRef.current?.focus();
        }
        if (e.key === 'ArrowRight') {
            agreeRef.current?.focus();
        }
    };

    return (<React.Fragment>
        <Dialog
            open={isOpen}
            onClose={(event, reason)=>{
                // if(loadingButtonState !== true) {
                //     clearAllFields()
                //     setIsOpen(false)
                // }
            }}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            scroll={'paper'}
            fullWidth={true}
            maxWidth={'xxl'}
            sx={{
                maxHeight: "100vh", // 限制 Dialog 最大高度
                overflow: "hidden", // 避免外部滚动条
                "& .MuiDialog-paper": {
                    maxHeight: "100vh", // 让 Dialog 内部 Paper 也受限
                    overflow: "hidden", // 避免不必要的外部滚动条
                },
            }}
        >

            <MDBox component="form"
                   role="form"
                   onSubmit={handleSubmit(onSubmit)}
                   onKeyDown={(e) => {
                       if (e.key !== 'Enter') return;

                       // 1️⃣ 只处理 DataGrid 里的事件
                       const gridRoot = e.target.closest('.MuiDataGrid-root');
                       if (!gridRoot) return;

                       // 2️⃣ 如果焦点在「可编辑输入控件」里 → 拦
                       const isEditingCell =
                           e.target.tagName === 'INPUT' ||
                           e.target.tagName === 'TEXTAREA' ||
                           e.target.getAttribute('role') === 'spinbutton';

                       if (isEditingCell) {
                           e.preventDefault();
                           e.stopPropagation();
                       }
                   }}
                   noValidate>
                <DialogTitle style={{ cursor: 'move', display: 'flex', justifyContent: 'space-between' ,alignItems: "center",
                    position: "sticky",
                    top: 0,
                    zIndex: 1100,
                    boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px',
                    }}
                            >
                    <Grid container>
                        <Grid item lg={8} md={12}>
                            {type === 'Add' && <div>{t('InboundPage.Add Warehousing Receipt')}</div>}
                            {type === 'Edit' && <div>{`${t('InboundPage.Edit Warehousing Receipt')} : ${data.applyAsnNo}`}</div>}
                            {type === 'Copy' && <div>{`${t('InboundPage.Copy Warehousing Receipt')} : ${data.applyAsnNo}`} </div>}
                            {type === 'Preview' && <div>{`${t('InboundPage.Preview Warehousing Receipt')} : ${data.applyAsnNo}`}</div>}
                        </Grid>
                        <Grid item lg={4} md={12} sx={{width:'100%'}}>
                            <Grid sx={{display:'flex',justifyContent:'flex-end',width:'100%'}}>
                                {
                                    !loading && !!previewData?.warehousing && type === 'Preview' &&
                                    <div>
                                        <div style={{
                                            marginRight:"20px",
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexDirection: 'row',
                                            justifyContent: 'flex-end'
                                        }}>
                                            {(data?.asnState === '0' || (data?.asnState === '10')) && checkPermission(PERMISSION_DICT.InboundDataModify) &&
                                                <Tooltip title={t('Edit')}>
                                                    <IconButton
                                                        // sx={(params?.row?.asnState === '60' ||params?.row?.asnState === '100'||params?.row?.asnState === '90')?{visibility:'hidden'}:{visibility:'visible'}}
                                                        disabled={data.asnState === '60' || data.asnState === '100' || data.asnState === '90'}
                                                        onClick={() => {
                                                            setTransferData(data);
                                                            setType('Edit');
                                                            const axiosPost = async () => {
                                                                if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)) {
                                                                    await dispatch(ownerSelected({
                                                                        condition: data?.ownerId,
                                                                        userName: LocalStorage.getItem('username')
                                                                    }, (data) => setOwnerId(data[0])))
                                                                }
                                                            }
                                                            axiosPost().then()
                                                            setIsOpen(true)
                                                        }}>
                                                        <EditIcon
                                                            color={data.asnState === '60' || data.asnState === '100' || data.asnState === '90' ? "disabled" : "primary"}>edit</EditIcon>
                                                    </IconButton>
                                                </Tooltip>
                                            }
                                            {checkPermission(PERMISSION_DICT.InboundDataAdd) &&
                                                <Tooltip title={t('Copy')}>
                                                    <IconButton
                                                        color="primary"
                                                        onClick={() => {
                                                            setTransferData(data);
                                                            setType('Copy');
                                                            const axiosPost = async () => {
                                                                if (checkPermission(PERMISSION_DICT.QueryOwnerInfo)) {
                                                                    await dispatch(ownerSelected({
                                                                        condition: data?.ownerId,
                                                                        userName: LocalStorage.getItem('username')
                                                                    }, (data) => setOwnerId(data[0])))
                                                                }
                                                            }
                                                            axiosPost().then()
                                                            setIsOpen(true)
                                                        }}>
                                                        <Icon>copy</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            }
                                            {
                                                (data.asnState === '60'
                                                    // || data.asnState === '90'
                                                    || data.asnState === '100')
                                                &&
                                                <Tooltip title={t('Print')}>
                                                    <IconButton
                                                        color="primary"
                                                        // color={data.asnState !== '60' ? 'disabled' : 'primary'}
                                                        // disabled={data.asnState !== '60' }
                                                        onClick={() => {
                                                            if (!!previewData?.warehousing?.omsExAsnNo){
                                                                setIsPrintOpen(true)
                                                                // setType('Print');
                                                                setCurrentRow(data)
                                                            }else {
                                                                setIsPrintAlertOpen(true)
                                                            }

                                                        }}>
                                                        <Icon>print</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            }
                                            {/*{(previewData?.warehousing?.asnState === '10' && checkPermission(PERMISSION_DICT.QueryOwnerInfo) && checkPermission(PERMISSION_DICT.InboundDataAudit)) &&*/}
                                            {/*    <div>*/}
                                            {/*        <Tooltip title={t('Audit')}>*/}
                                            {/*            <IconButton*/}
                                            {/*                color={'primary'}*/}
                                            {/*                disabled={!checkPermission(PERMISSION_DICT.InboundDataAudit)}*/}
                                            {/*                onClick={() => {*/}
                                            {/*                    setCurrentRow(previewData.warehousing)*/}
                                            {/*                    changeASNStatus(previewData.warehousing)*/}
                                            {/*                    setType('Submit')*/}
                                            {/*                    setIsOpen(false)*/}
                                            {/*                }}>*/}
                                            {/*                <AssignmentTurnedInOutlinedIcon />*/}
                                            {/*            </IconButton>*/}
                                            {/*        </Tooltip>*/}
                                            {/*    </div>*/}
                                            {/*}*/}
                                            {((previewData?.warehousing?.asnState === '0' || previewData?.warehousing?.asnState === '10') && checkPermission(PERMISSION_DICT.InboundDataSubmit)) &&
                                                <div>
                                                    <Tooltip title={t('Submit')}>
                                                        <IconButton
                                                            color={'primary'}
                                                            disabled={!checkPermission(PERMISSION_DICT.InboundDataSubmit)}
                                                            onClick={() => {
                                                                setIsSubmitAlertOpen(true)
                                                                // setIsOpen(false)
                                                            }}>
                                                            <PublishIcon/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            }

                                            {
                                                // checkPermission(PERMISSION_DICT.InboundDataSubmit &&
                                                // <div>
                                                //     <Tooltip title={t('Withdraw')}>
                                                //         <IconButton
                                                //             color={'primary'}
                                                //             // disabled={!checkPermission(PERMISSION_DICT.InboundDataWithdraw)}
                                                //             onClick={() => {
                                                //                 setIsWithdrawAlertOpen(true)
                                                //             }}>
                                                //             <ReplayIcon/>
                                                //         </IconButton>
                                                //     </Tooltip>
                                                // </div>
                                            }

                                            {
                                                checkDeletable(previewData) && checkPermission(PERMISSION_DICT.InboundDataDelete) &&
                                                <Tooltip title={t("Delete")}>
                                                    <IconButton
                                                        color="primary"
                                                        onClick={() => {
                                                            setDeleteOpen(true);
                                                        }}>
                                                        <Icon color='error'>delete_forever</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                                //inbound cancel request
                                                // checkDeletable(previewData) && checkPermission(PERMISSION_DICT.InboundDataDelete) &&
                                                // <div>
                                                //     <InboundCancelReasonDialog
                                                //         previewData={previewData}
                                                //         setIsPreviewOpen={setIsOpen}
                                                //         setPageLoading={setPageLoading}
                                                //         onRerender={onRerender}
                                                //         pageFormData={pageFormData}
                                                //     />
                                                // </div>
                                            }
                                        </div>
                                    </div>
                                }
                                <IconButton  disabled={loadingButtonState} onClick={() => {
                                    if(loadingButtonState !== true) {
                                        clearAllFields()
                                        setIsOpen(false)
                                    }

                                }}>

                                    <Icon>cancel</Icon>
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>

                </DialogTitle>
                <DialogContent sx={{
                    maxHeight: "80vh", // 限制最大高度，防止 Dialog 过长
                    overflowY: "auto", // 允许滚动
                }} >
                    <DialogContentText>
                        {type !== 'Preview' ?
                            <MDBox pt={2} pb={2} px={3}
                                   sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                                <Slide timeout={200} direction={'left'} in={isOpen} mountOnEnter unmountOnExit>
                                    <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'center' }}>

                                        <Grid item xs={12} mt={2} mb={2} sx={closeWarning ? { display: 'none' } : {}}>
                                            <Alert severity="warning" onClose={() => setCloseWarning(true)}>
                                                {t('InboundPage.One warehouse receipt only corresponds to one carrier express package. If you want to warehouse multiple express packages, please split the warehouse receipt')}
                                            </Alert>
                                        </Grid>
                                        {
                                            checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&
                                            <Grid item xs={12} md={12} mb={2} sx={{ minWidth: 250 }}>
                                                <FormControl fullWidth error={!!errors.owner}>
                                                    <Autocomplete
                                                        required
                                                        disablePortal={false}
                                                        options={ownerList}
                                                        readOnly={type === 'Preview'}
                                                        disabled={type === 'Edit' || type === 'Copy'}
                                                        getOptionLabel={(option) => `ID: ${option?.ownerId} Name: ${option?.ownerName}`}
                                                        isOptionEqualToValue={(option, value) => option?.ownerId === value?.ownerId}
                                                        value={ownerId}
                                                        onChange={(e, v) => {
                                                            setOwnerId(v)
                                                            setPackage(null)
                                                            setSelectedCustomer(null)
                                                            setRows([])
                                                            if (!v && checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
                                                                dispatch({
                                                                    type:InventoryActionType.SKU_CHOICE_PRODUCT,
                                                                    payload:[]
                                                                })
                                                                dispatch({
                                                                    type:InboundsActionType.CUSTOMER_LIST,
                                                                    payload:[]
                                                                })
                                                            }
                                                        }}
                                                        onInputChange = {(event, newInputValue)=> setInputOwnerValue(newInputValue)}
                                                        renderInput={(params) =>
                                                            <MDInput
                                                                {...params}
                                                                label={t("Owner ID or Name")}
                                                                required
                                                                InputLabelProps={{ shrink: true }}
                                                            />}
                                                        noOptionsText={t('No Options')}
                                                    />
                                                    <FormHelperText
                                                        sx={{ fontWeight: 'medium' }}>{errors?.owner?.message}</FormHelperText>
                                                </FormControl>
                                            </Grid>
                                        }


                                        <Grid item xs={12} md={6} mb={0} sx={{ minWidth: 250 }}>
                                            <FormControl
                                                error={!!errors.fromOrderNo}
                                                fullWidth
                                            >
                                                <MDInput
                                                    label={t('InboundPage.From Order No.')}
                                                    fullWidth
                                                    required
                                                    disabled={type === 'Preview' || type === 'Edit'}
                                                    {...register("fromOrderNo")}
                                                    error={!!errors?.fromOrderNo}
                                                    minLength={300}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                                <FormHelperText
                                                    sx={{ fontWeight: 'medium',minHeight: '1.5em' }}>{errors?.fromOrderNo?.message}</FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        {/*<Grid item xs={12} md={6} mb={2} sx={{ minWidth: 250 }}>*/}
                                        {/*    <FormControl fullWidth required*/}
                                        {/*                 error={!!errors?.businessType} {...register('businessType')}>*/}
                                        {/*        <Autocomplete*/}
                                        {/*            required*/}
                                        {/*            error={!!errors?.businessType}*/}
                                        {/*            readOnly={type === 'Preview'}*/}
                                        {/*            disabled={true}*/}
                                        {/*            {...register('businessType')}*/}
                                        {/*            disablePortal={false}*/}
                                        {/*            options={*/}
                                        {/*                businessTypeArr*/}
                                        {/*            }*/}
                                        {/*            getOptionLabel={(option) => `${option?.label}`}*/}
                                        {/*            isOptionEqualToValue={(option, value) => option?.id === value?.id}*/}
                                        {/*            value={businessType}*/}
                                        {/*            onChange={(e, v) => {*/}
                                        {/*                setBusinessType(v)*/}
                                        {/*            }}*/}
                                        {/*            renderInput={(params) =>*/}
                                        {/*                <MDInput*/}
                                        {/*                    required*/}
                                        {/*                    {...register('businessType')}*/}
                                        {/*                    {...params}*/}
                                        {/*                    label={t('InboundPage.Business Type')}*/}
                                        {/*                    InputLabelProps={{ shrink: true }}*/}
                                        {/*                    error={!!errors?.businessType}*/}

                                        {/*                />}*/}
                                        {/*        />*/}
                                        {/*        <FormHelperText*/}
                                        {/*            sx={{ fontWeight: 'medium' }}>{errors?.businessType?.message}</FormHelperText>*/}

                                        {/*    </FormControl>*/}

                                        {/*</Grid>*/}
                                        <Grid item xs={12} md={6} mb={0} sx={{ minWidth: 250 }}>
                                            <FormControl
                                                fullWidth required
                                                error={!!errors?.date} {...register('date')}>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <MuiDatePicker
                                                        sx={{
                                                            '& .MuiButton-root': {
                                                                color: 'red'
                                                            },
                                                        }}
                                                        disabled={type === 'Preview'}
                                                        fullWidth
                                                        error={!!errors?.date}
                                                        {...register('date')}
                                                        label={t("InboundPage.Expected Arrival Time")}
                                                        // 使用自定义函数计算三个工作日后的日期
                                                        minDate={getMinBusinessDate(3)}
                                                        value={date}
                                                        onChange={(newValue) => {
                                                            if (newValue) {
                                                                clearErrors('date');
                                                            }
                                                            setDate(newValue);
                                                        }}
                                                        shouldDisableDate={(date) => {
                                                            const day = date.isoWeekday();
                                                            return day === 6 || day === 7;
                                                        }}
                                                        slotProps={{
                                                            textField: {
                                                                required: true,
                                                                shrink: true
                                                            },
                                                        }}
                                                    />

                                                </LocalizationProvider>
                                                <FormHelperText
                                                    sx={{
                                                        fontWeight: errors?.date?.message ? 'medium' : 'normal',
                                                        minHeight: '1.5em'
                                                    }}>
                                                    {errors?.date?.message || t("InboundPage.Please select a date at least three working days later")}</FormHelperText>
                                            </FormControl>

                                        </Grid>
                                        <Grid item xs={12} md={6} mb={2} sx={{ minWidth: 250 }}>
                                            <FormControl fullWidth error={!!errors.warehouse}>
                                                <Autocomplete
                                                    disableClearable
                                                    required
                                                    inputValue={warehouseInput}
                                                    onInputChange={(_, v, reason) => {
                                                        setWarehouseInput(v);
                                                        setIsTyping(reason === 'input' && v.trim() !== '');
                                                    }}
                                                    disablePortal={false}
                                                    error={!!errors.warehouse}
                                                    // options={warehouseList}
                                                    // options={
                                                    //     checkPermission(PERMISSION_DICT.QueryOwnerInfo) ?
                                                    //         // warehouseList
                                                    //         [...warehouseList.filter((ele)=>inboundWarehouseList.some((v)=>v.warehouseId === ele.dictValue)), { dictLabel: t('InboundPage.More Options'), isMoreButton: true }]
                                                    //         :
                                                    //         [...warehouseList?.filter((ele)=>inboundWarehouseList.some((v)=>v.warehouseId === ele.dictValue)).filter((ele)=>warehouseListOwner.find((v)=>v.dictValue === ele.dictValue)), { dictLabel: t('More Options'), isMoreButton: true }]
                                                    // }
                                                    options={computedOptions}
                                                    filterOptions={keepMoreAtEnd}
                                                    readOnly={type === 'Preview'}
                                                    getOptionLabel={(option) => `${option?.dictLabel}`}
                                                    isOptionEqualToValue={(option, value) => option?.dictValue === value?.dictValue}
                                                    value={warehouse}
                                                    // onChange={(e, v) => setWarehouse(v)}
                                                    onChange={(e, v) => {
                                                        if (v?.isMoreButton) {
                                                            handleOpenWarehouseFilterDialog();
                                                        } else {
                                                            setWarehouse(v);
                                                        }
                                                        setIsTyping(false);
                                                    }}
                                                    renderInput={(params) =>
                                                        <MDInput
                                                            {...params}
                                                            label={t("InboundPage.Ship to Warehouse")}
                                                            required
                                                            // 关键1：合并后强制收缩 label，这样 placeholder 才会常显
                                                            InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
                                                            // 关键2：直接给底层 input 的 placeholder（避免被 params 覆盖）
                                                            inputProps={{ ...params.inputProps, placeholder: t("Search by city or warehouse ID") }}
                                                            placeholder={t("Enter City or Warehouse ID")}
                                                            color='warning'
                                                            data-cy="inbound-warehouse-input"
                                                            // error={!!errors.warehouse}
                                                            // 关键：自定义 endAdornment，把搜索按钮放在下拉箭头左边
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                endAdornment: (
                                                                    <>
                                                                        <InputAdornment position="end" sx={{ mr: 0.5 }}>
                                                                            <MDButton
                                                                                size="small"
                                                                                color="primary"
                                                                                onMouseDown={(e) => e.preventDefault()}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();                   // 不触发下拉
                                                                                    if (type !== 'Preview') handleOpenWarehouseFilterDialog();
                                                                                    setIsTyping(false);
                                                                                }}
                                                                                disabled={type === 'Preview'}
                                                                                startIcon={<SearchIcon />}
                                                                                sx={{ ml: 0.5, textTransform: 'none', borderRadius: 2 }}
                                                                            >
                                                                                {t('Advanced Filters')}
                                                                            </MDButton>
                                                                        </InputAdornment>

                                                                        {/* 保留原本的清除/下拉图标 */}
                                                                        {params.InputProps.endAdornment}
                                                                    </>
                                                                ),
                                                            }}
                                                        />}
                                                />
                                                <FormHelperText
                                                    sx={{ fontWeight: 'medium' }}>{errors?.warehouse?.message}</FormHelperText>
                                            </FormControl>
                                        </Grid>


                                        <Grid item xs={12} md={12} mb={2} sx={{minWidth: 250}}>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    required
                                                    filterSelectedOptions
                                                    error={!!errors.product}
                                                    disablePortal={false}
                                                    filterOptions={(a) => a.filter(value => (value?.sku?.toUpperCase().includes(inputProductValueDebounce.toUpperCase())) || (value?.productName?.toUpperCase().includes(inputProductValueDebounce.toUpperCase())) || (value?.skuAlias?.toUpperCase().includes(inputProductValueDebounce.toUpperCase())))}
                                                    readOnly={type === 'Preview'}
                                                    options={kitProductList
                                                        // .filter(product => !rows.some(row => row.sku === product.sku))
                                                        .sort((a, b) => {
                                                        if (a?.groupMessage === validPackMsg && b?.groupMessage === invalidPackMsg) {
                                                            return -1;
                                                        } else if (a?.groupMessage === invalidPackMsg && b?.groupMessage === validPackMsg) {
                                                            return 1;
                                                        } else {
                                                            return 0;
                                                        }
                                                    })}
                                                    // options={kitProductList.filter(product => !rows.some(row => row.sku === product.sku))}
                                                    groupBy={(option) => option.groupMessage}
                                                    getOptionDisabled={(option) =>
                                                        option.wrongFlag === true
                                                    }
                                                    getOptionLabel={(option) => `SKU:${option.sku}`}
                                                    isOptionEqualToValue={(option, value) => option?.sku === value?.sku}
                                                    value={null} // 始终清空当前选择
                                                    onChange={(e, v) => {
                                                        setPackage(v); // 如果需要处理选项，可在这里获取 v 的值
                                                        setInputProductValue(''); // 清空输入框的值
                                                    }}
                                                    // onChange={(e, v) => setPackage(v)}
                                                    onInputChange={(event, newInputValue) => {
                                                        setInputProductValue(newInputValue);
                                                    }}
                                                    renderOption={(props, option) => (option.wrongFlag ?<li {...props} >
                                                        <div style={{fontWeight: 'bolder'}}>SKU:&nbsp;</div>
                                                        <div> {option?.sku}</div>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <div style={{fontWeight: 'bolder'}}>SKU Alias:&nbsp;</div>
                                                        <div> {option?.skuAlias}</div>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <div style={{fontWeight: 'bolder'}}>Product Name:&nbsp;</div>
                                                        <div> {option?.productName}</div>
                                                        <Tooltip title={'copy sku'}>
                                                    <span
                                                        style={{
                                                            display: 'inline-block',
                                                            cursor: option.wrongFlag ? 'pointer' : 'not-allowed',
                                                            pointerEvents: option.wrongFlag ? 'auto' : 'none',
                                                        }}
                                                    >
                                                        <IconButton
                                                            color = 'primary'
                                                            style={{
                                                                padding:'0',
                                                                color: 'red',
                                                                pointerEvents: 'auto',
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleClickCopy(option?.sku);
                                                            }}
                                                        > <Icon>copy</Icon>
                                                        </IconButton>
                                                    </span>
                                                        </Tooltip>
                                                    </li>:<li {...props} >
                                                        <div style={{fontWeight: 'bolder'}}>{`${t('SKU')}`}:&nbsp;</div>
                                                        <div> {option?.sku}</div>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <div style={{fontWeight: 'bolder'}}>{`${t('SKU Alias')}`}:&nbsp;</div>
                                                        <div> {option?.skuAlias}</div>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <div style={{fontWeight: 'bolder'}}>{`${t('ProductPage.productName')}`}:&nbsp;</div>
                                                        <div> {option?.productName}</div>
                                                    </li>)}
                                                    renderInput={(params) =>
                                                        <MDInput
                                                            required
                                                            {...params}
                                                            // error={!!errors.product}
                                                            label={t("Select Product (Multiple Choices)")}
                                                            placeholder={t('Enter Product SKU, SKU Alias or Product Name')}
                                                            InputLabelProps={{shrink: true}}
                                                        />}
                                                    noOptionsText={t('No Options')}
                                                />

                                            </FormControl>
                                        </Grid>

                                        <Fade in={show}>
                                            <Grid item xs={12} md={12} mb={2}
                                                  sx={show ? { minWidth: 250 } : { minWidth: 250, display: 'none' }}>
                                                <MuiDataGrid
                                                    localeText={LocalStorage.getItem('i18nextLng') === 'zh' ? zhCN.components.MuiDataGrid.defaultProps.localeText : enUS.components.MuiDataGrid.defaultProps.localeText}
                                                    rows={rows}
                                                    getRowId={(row) => row?.id}

                                                    columns={[

                                                        {
                                                            field: 'sku',
                                                            headerName: t('InboundPage.Product SKU *'),
                                                            width: 120,
                                                            editable: false,
                                                        },

                                                        {
                                                            field: 'skuAlias',
                                                            headerName: t('InboundPage.Product SKU Alias *'),
                                                            width: 150,
                                                            editable: false,
                                                        },

                                                        {
                                                            field: 'productName',
                                                            headerName: t('ProductPage.productName'),
                                                            width: 150,
                                                            editable: false,
                                                        },

                                                        {
                                                            field: 'unit',
                                                            headerName: t('InboundPage.Unit *'),
                                                            type: 'singleSelect',
                                                            editable: type !== 'Preview',
                                                            valueOptions: UnitArray,
                                                            getOptionValue: (value) => value?.value,
                                                            getOptionLabel: (value) => `${value?.label}`,
                                                            width: 90,
                                                            preProcessEditCellProps: (params) => {

                                                                let sku = params?.row?.sku
                                                                let product = kitProductList.find(ob => ob.sku === sku)

                                                                let packageOb = product?.packages.find(ob => ob.unit === params.props.value)

                                                                if (!packageOb&& !!product) {
                                                                    dispatch(onErrorAlert(`${t('InboundPage.This product do not have the unit')}:${params?.props?.value},${t('InboundPage.please select other one')}`))
                                                                    return { ...params.props, error: true };
                                                                } else {
                                                                    return { ...params.props, error: false };
                                                                }


                                                            },

                                                        },

                                                        {
                                                            field: "qty",
                                                            headerName: t('InboundPage.Quantity *'),
                                                            type: "number",
                                                            width: 90,
                                                            align: "left",
                                                            headerAlign: "left",
                                                            editable: type !== 'Preview',
                                                            renderEditCell: (params) => (
                                                                <GridEditInputCell
                                                                    {...params}
                                                                    inputProps={{
                                                                        min: 1,
                                                                        onWheel: (e) => {
                                                                            e.target.blur();
                                                                        },
                                                                    }}
                                                                />
                                                            ),
                                                            // preProcessEditCellProps: (params) => {
                                                            //
                                                            //     if (!params.props.value) {
                                                            //         dispatch(onErrorAlert(t('InboundPage.The quantity must be an integer that is equal to or greater than zero.')))
                                                            //         return { ...params.props, error: true };
                                                            //     }
                                                            //     const hasError = params.props.value < 1 || typeof params.props.value !== 'number' || params.props.value % 1 !== 0;
                                                            //     if (hasError) {
                                                            //         dispatch(onErrorAlert(t('InboundPage.The quantity must be an integer that is equal to or greater than zero.')))
                                                            //     }
                                                            //     return { ...params.props, error: hasError };
                                                            // },
                                                        },
                                                        {
                                                            field: "price",
                                                            headerName: t('InboundPage.Price *'),
                                                            type: "number",
                                                            width: 120,
                                                            align: "left",
                                                            headerAlign: "left",
                                                            editable: false,
                                                            renderEditCell: (params) => (
                                                                <GridEditInputCell
                                                                    {...params}
                                                                    inputProps={{
                                                                        min: "0",
                                                                        step: "0.01",
                                                                    }}
                                                                    required={true}
                                                                />
                                                            ),
                                                            preProcessEditCellProps: (params) => {

                                                                if (params.props.value === null) {
                                                                    dispatch(onErrorAlert(t('InboundPage.Price cannot be empty')))
                                                                    return { ...params.props, error: true };
                                                                }

                                                                const hasError = params.props.value <= 0;
                                                                if (hasError) {
                                                                    dispatch(onErrorAlert(t('InboundPage.Not allowed equal or less than 0')))
                                                                }
                                                                return { ...params.props, error: hasError };
                                                            },
                                                        },
                                                        {
                                                            field: 'batch',
                                                            headerName: t('InboundPage.Batch No.'),
                                                            width: 150,
                                                            editable: type !== 'Preview',
                                                            renderEditCell: (params) => (
                                                                <GridEditInputCell
                                                                    {...params}
                                                                />
                                                            ),

                                                        },
                                                        {
                                                            field: 'productionDate',
                                                            headerName: t('InboundPage.Batch Production Date'),
                                                            type: 'date',
                                                            width: 150,
                                                            editable: type !== 'Preview',
                                                        },
                                                        {
                                                            field: 'expirationDate',
                                                            headerName: t('InboundPage.Batch Expiration Date'),
                                                            type: 'date',
                                                            width: 140,
                                                            editable: type !== 'Preview',
                                                            renderEditCell: (params) => (
                                                                <GridEditDateCell
                                                                    {...params}
                                                                    inputProps={{
                                                                        minDate: new Date()
                                                                    }}
                                                                    minDate={new Date()}
                                                                    required={true}
                                                                />)
                                                        },
                                                        {
                                                            field: "actions",
                                                            type: "actions",
                                                            headerName: t("ProductPage.actions"),
                                                            width: 120,
                                                            cellClassName: "actions",
                                                            getActions: ({ id }) => {
                                                                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                                                                if (isInEditMode) {
                                                                    return [
                                                                        <GridActionsCellItem
                                                                            icon={<SaveIcon />}
                                                                            label="Save"
                                                                            disabled={type === 'Preview'}
                                                                            sx={{
                                                                                color: "primary.main",
                                                                            }}
                                                                            onClick={handleSaveClick(id)}
                                                                        />,
                                                                        <GridActionsCellItem
                                                                            icon={<CancelIcon />}
                                                                            label="Cancel"
                                                                            disabled={type === 'Preview'}
                                                                            className="textPrimary"
                                                                            onClick={handleCancelClick(id)}
                                                                            color="inherit"
                                                                        />,
                                                                    ];
                                                                }

                                                                return [
                                                                    <GridActionsCellItem
                                                                        icon={<EditIcon />}
                                                                        label="Edit"
                                                                        disabled={type === 'Preview'}
                                                                        className="textPrimary"
                                                                        onClick={handleEditClick(id)}
                                                                        color="inherit"
                                                                    />,
                                                                    <GridActionsCellItem
                                                                        icon={<DeleteIcon />}
                                                                        label="Delete"
                                                                        disabled={type === 'Preview'}
                                                                        onClick={handleDeleteClick(id)}
                                                                        color="inherit"
                                                                    />,
                                                                ];
                                                            },
                                                        },
                                                    ]}
                                                    autoHeight
                                                    sx={{
                                                        "& .MuiDataGrid-virtualScroller": { overflow: 'visible' },
                                                        width: 'auto'
                                                    }}
                                                    editMode="row"
                                                    rowModesModel={rowModesModel}
                                                    onRowModesModelChange={handleRowModesModelChange}
                                                    onRowEditStop={handleRowEditStop}
                                                    processRowUpdate={processRowUpdate}
                                                    slotProps={{
                                                        toolbar: { setRows, setRowModesModel },
                                                    }}
                                                    hideFooter
                                                />
                                            </Grid>
                                        </Fade>
                                        <Grid item xs={12} md={6} mb={2} sx={{ minWidth: 250 }}>
                                            <FormControl
                                                error={!!errors.carrierId}
                                                fullWidth
                                            >
                                                <MDInput
                                                    label={t('InboundPage.Carrier ID')}
                                                    fullWidth
                                                    disabled={type === 'Preview'}
                                                    {...register("carrierId")}
                                                    error={!!errors?.carrierId}
                                                    minLength={300}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                                <FormHelperText
                                                    sx={{ fontWeight: 'medium' }}>{errors?.carrierId?.message}</FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={6} mb={2} sx={{ minWidth: 250 }}>
                                            <FormControl
                                                error={!!errors.carrierOrderNo}
                                                fullWidth
                                            >
                                                <MDInput
                                                    label={t('InboundPage.Carrier Tracking No.')}
                                                    fullWidth
                                                    disabled={type === 'Preview'}
                                                    {...register("carrierOrderNo")}
                                                    error={!!errors?.carrierOrderNo}
                                                    minLength={300}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                                <FormHelperText
                                                    sx={{ fontWeight: 'medium' }}>{errors?.carrierOrderNo?.message}</FormHelperText>
                                            </FormControl></Grid>
                                        <Grid item xs={12} md={12} mb={2} sx={{ minWidth: 250 }}>
                                            <FormControl fullWidth error={!!errors.customer}>
                                                <Autocomplete
                                                    required
                                                    filterSelectedOptions
                                                    disablePortal={false}
                                                    readOnly={type === 'Preview'}
                                                    options={customerList.map((ele)=>{
                                                        return {...ele,id: uuidv4()}
                                                    })}
                                                    disabled={loadCustomer}
                                                    filterOptions={(a) => a.filter(value => (value.customerId?.toUpperCase().includes(inputValueDebounce.toUpperCase())) || (value.contact?.toUpperCase().includes(inputValueDebounce.toUpperCase())))}
                                                    getOptionLabel={(option) => `${t('InboundPage.Customer_ID')}:${option.customerId}`}
                                                    value={selectedCustomer}
                                                    onInputChange={(event, newInputValue) => {
                                                        setInputValue(newInputValue);
                                                    }}
                                                    onChange={(e, v) => setSelectedCustomer(v)}
                                                    renderOption={(props, option) => (<li {...props} key={option.id} >
                                                        <div style={{ fontWeight: 'bolder' }}>{`${t('InboundPage.Customer_ID')}`}:&nbsp;</div>
                                                        <div> {option?.customerId}</div>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <div style={{ fontWeight: 'bolder' }}>{`${t('InboundPage.Contact Name')}`}:&nbsp;</div>
                                                        <div> {option?.contact}</div>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <div style={{ fontWeight: 'bolder' }}>{`${t('Address')}`}:&nbsp;</div>
                                                        <div> {`${option?.address} ${option?.city} ${option?.province} ${option?.countryCode} ${option?.zipcode}`}</div>
                                                        &nbsp;&nbsp;&nbsp;
                                                    </li>)}
                                                    noOptionsText={t('No Options')}
                                                    renderInput={(params) =>
                                                        <MDInput
                                                            {...params}
                                                            required
                                                            label={t("InboundPage.Ship from")}
                                                            // placeholder={t('InboundPage.Enter Customer ID or Name')}
                                                            placeholder={
                                                                loadCustomer
                                                                    ? t('InboundPage.Loading Customer...')
                                                                    : t('InboundPage.Enter Customer ID or Name')
                                                            }
                                                            InputLabelProps={{ shrink: true }}
                                                        />}
                                                />

                                                <FormHelperText
                                                    sx={{ fontWeight: 'medium' }}>{errors?.customer?.message}</FormHelperText>

                                            </FormControl>
                                        </Grid>
                                        <Fade in={custShow}>
                                            <Grid item xs={12} md={12} mb={2}
                                                  sx={custShow ? { minWidth: 250 } : { minWidth: 250, display: 'none' }}>
                                                <Card
                                                    sx={darkMode ? { border: '1px solid white' } : { border: '1px solid #3f50b5' }}>
                                                    <Grid container xs={12} alignItems={'center'} p={1}>
                                                        <Grid item container xs={12} p={1} alignItems={'center'}
                                                              justifyContent={'space-between'} spacing={2}>
                                                            <Grid item xs={12}
                                                                  // md={6}
                                                                  sx={(theme) => ({
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.background.default,
                                                                },
                                                            })}>
                                                                <MDTypography color={'primary'} variant={'h6'}
                                                                              fontWeight={'bold'}>{t("InboundPage.Customer Address Information")}</MDTypography>
                                                            </Grid>

                                                            <Grid item xs={12} md={6} sx={(theme) => ({
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.background.default,

                                                                },
                                                            })}>
                                                                <MDTypography variant={'button'}
                                                                              fontWeight={'bold'}>{`${t('CustomerPage.Customer ID')}: ${selectedCustomer?.customerId}`}</MDTypography>
                                                            </Grid>
                                                            <Grid item xs={12} md={6} sx={(theme) => ({
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.background.default,

                                                                },
                                                            })}>
                                                                <MDTypography variant={'button'}
                                                                              fontWeight={'bold'}>{`${t('CustomerPage.Customer Name')}: ${selectedCustomer?.name}`}</MDTypography>
                                                            </Grid>
                                                            <Grid item xs={12} md={6} sx={(theme) => ({
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.background.default,

                                                                },
                                                            })}>
                                                                <MDTypography variant={'button'}
                                                                              fontWeight={'bold'}>{`${t('CustomerPage.Customer Contact')}: ${selectedCustomer?.contact}`}</MDTypography>
                                                            </Grid>
                                                            <Grid item xs={12} md={6} sx={(theme) => ({
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.background.default,

                                                                },
                                                            })}>
                                                                <MDTypography variant={'button'}
                                                                              fontWeight={'bold'}>{`${t('CustomerPage.Customer Phone No.')}: ${selectedCustomer?.phone}`}</MDTypography>
                                                            </Grid>
                                                            <Grid item sx={(theme) => ({
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.background.default,

                                                                },
                                                            })}>
                                                                <MDTypography variant={'button'}
                                                                              fontWeight={'medium'}>{`${t('Address')}: ${selectedCustomer?.address} ${selectedCustomer?.city} ${selectedCustomer?.province} ${selectedCustomer?.country} ${selectedCustomer?.zipcode}`}</MDTypography>
                                                            </Grid>
                                                            <Grid item xs={12} md={6} sx={(theme) => ({
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.background.default,

                                                                },
                                                            })}>
                                                                <MDTypography variant={'button'}
                                                                              fontWeight={'bold'}>{`${t('AccountPage.Address 2')}: ${selectedCustomer?.address2}`}</MDTypography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Card>
                                            </Grid>
                                        </Fade>


                                    </Grid>
                                </Slide>

                            </MDBox> :
                            <MDBox mb={3} p={3} pt={0}>


                                <Grid container spacing={3} flexDirection={'row'} alignItems={'start'} mt={1}>
                                    <Grid item container xs={12} spacing={1}>
                                        <Grid item xs={12} >
                                            <InboundDetail info={previewData?.warehousing} loading={loading}/>
                                        </Grid>
                                        <Grid item xs={12} mt={5}>
                                            <InboundProductDetail list={previewData?.details} listActual={previewData?.inboundDetails} loading={loading}/>
                                        </Grid>
                                        <Grid item xs={12} mt={5}>
                                            <CarriersInformation info={previewData?.warehousing} loading={loading}/>
                                        </Grid>

                                        <Grid item xs={12} mt={5}>
                                            <OperationInfo info={previewData?.warehousing} loading={loading}/>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </MDBox>
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton variant={'outlined'} color='primary' disabled={loadingButtonState}  onClick={() => {

                        if(loadingButtonState !== true) {
                            clearAllFields()
                            setIsOpen(false)
                        }

                    }}
                    >
                        {t(`Cancel`)}
                    </MDButton>
                    {
                        <LoadingButton
                            //loading
                            name="action"
                            value="saveOnly"
                            variant={'contained'}
                            type={'submit'}
                            loading={loadingButtonState && loadingType === 'saveOnly' }
                            disabled={!custShow || loadingButtonState}
                            sx={type === 'Preview' ? {display: 'none', backgroundColor: '#3F50B5', // 设置背景颜色
                                '&:hover': {
                                    backgroundColor: '#3F50B5', // 悬停时保持相同颜色
                                },} : {display: 'block', backgroundColor: '#3F50B5', // 设置背景颜色
                                '&:hover': {
                                    backgroundColor: '#3F50B5', // 悬停时保持相同颜色
                                },}}>
                            {t('OutboundPage.save only')}
                        </LoadingButton>
                    }
                    {
                        ((type === "Add" || type === "Copy")&& checkPermission(PERMISSION_DICT.InboundDataSubmit))
                        // || (type === "Edit"&& checkPermission(PERMISSION_DICT.OutboundWholesaleModifyAndSubmit)))
                        &&
                        <LoadingButton
                            //loading
                            name="action"
                            value="saveAndSubmit"
                            variant={'contained'}
                            loading={loadingButtonState && loadingType === 'saveAndSubmit'}
                            disabled={!custShow || loadingButtonState}
                            type={'submit'}
                            sx={type === 'Preview' ? {display: 'none', backgroundColor: '#3F50B5',
                                '&:hover': {
                                    backgroundColor: '#3F50B5',
                                },} : {display: 'block', backgroundColor: '#3F50B5', // 设置背景颜色
                                '&:hover': {
                                    backgroundColor: '#3F50B5', // 悬停时保持相同颜色
                                },}}>
                            {t('OutboundPage.save and submit')}
                        </LoadingButton>
                    }
                    {
                        type === "Edit"&& checkPermission(PERMISSION_DICT.InboundDataSubmit)
                        &&
                        <LoadingButton
                            //loading
                            name="action"
                            value="saveAndSubmit"
                            variant={'contained'}
                            loading={loadingButtonState && loadingType === 'saveAndSubmit'}
                            disabled={!custShow || loadingButtonState}
                            type={'submit'}
                            sx={type === 'Preview' ? {display: 'none', backgroundColor: '#3F50B5',
                                '&:hover': {
                                    backgroundColor: '#3F50B5',
                                },} : {display: 'block', backgroundColor: '#3F50B5', // 设置背景颜色
                                '&:hover': {
                                    backgroundColor: '#3F50B5', // 悬停时保持相同颜色
                                },}}>
                            {t('InboundPage.edit and submit')}
                        </LoadingButton>
                    }
                </DialogActions>
            </MDBox>
        </Dialog>
        <Dialog
            open={isAlertOpen}
            onClose={() => setIsAlertOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
        >
            <DialogTitle id="alert-dialog-title">
                <div>{t("Are you sure?")}</div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('InboundPage.Do you really want to delete product SKU')}
                    <span style={{color: 'red', padding: '10px', fontWeight: 'bold'}}>{currentDeletedObject?.sku}</span>
                    ? {t('This process cannot be undone')}
                </DialogContentText>
            </DialogContent>
            <DialogActions onKeyDown={handleKeyDown}>
                <MDButton
                    variant={'outlined'} color='primary'
                    ref={disagreeRef}
                    onClick={() => {
                    setCurrentDeletedObject(null)
                    setIsAlertOpen(false)
                }}>
                    {t('Disagree')}
                </MDButton>

                <MDButton
                    color="primary"
                    ref={agreeRef}
                    autoFocus
                    onClick={() => {
                    setRows(rows.filter((row) => row.id !== currentDeletedObject?.id));
                    setIsAlertOpen(false)
                    setCurrentDeletedObject(null)
                }}>{t('Agree')}</MDButton>
            </DialogActions>
        </Dialog>

        <Dialog
            open={isSubmitAlertOpen}
            onClose={(event, reason) => {
                if(loadingButtonState !== true) {
                    setIsSubmitAlertOpen(false)
                }
            }}
            // onClose={() => setIsSubmitAlertOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
        >
            <DialogTitle id="alert-dialog-title">
                <div>{t("ReturnsPage.Submit Confirmation")}</div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('InboundPage.Do you want to submit warehousing receipt')}
                    <span style={{color: 'dodgerblue', padding: '10px', fontWeight: 'bold'}}>{data.applyAsnNo}</span>
                    ? {t('This process cannot be undone')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton disabled={loadingButtonState} onClick={() => {
                    setIsSubmitAlertOpen(false)
                }}>
                    {t('Disagree')}
                </MDButton>

                <LoadingButton
                    loadingIndicator={
                        <CircularProgress size={18} sx={{ color: 'dodgerblue' }} />
                    }
                    sx={{color:"dodgerblue","&:hover": {
                            color: "dodgerblue"
                        }}}
                    loading={loadingButtonState}

                    onClick={() => {
                        setLoadingButtonState(true)
                    setCurrentRow(previewData.warehousing)
                    changeASNStatus(previewData.warehousing,setLoadingButtonState,setIsSubmitAlertOpen)
                }}>{t('Agree')}</LoadingButton>
            </DialogActions>
        </Dialog>

        <Dialog
            open={isWithdrawAlertOpen}
            onClose={() => setIsWithdrawAlertOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
        >
            <DialogTitle id="alert-dialog-title">
                <div>{"Submit Confirmation"}</div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t('Do you want to withdraw warehousing receipt:')}
                    <span style={{color: 'red', padding: '5px', fontWeight: 'bold'}}>{data.applyAsnNo}</span>
                    ? {t('This process cannot be undone')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton onClick={() => {
                    setIsWithdrawAlertOpen(false)
                }}>
                    {t('Disagree')}
                </MDButton>

                <MDButton onClick={() => {
                    withdrawInbound()
                }}>{t('Agree')}</MDButton>
            </DialogActions>
        </Dialog>
        {/*<InboundCustomerAddressEditor*/}
        {/*    isOpen={isAddressOpen}*/}
        {/*    setIsOpen={setIsAddressOpen}*/}
        {/*    selectedCustomer={selectedCustomer}*/}
        {/*    setSelectedCustomer={setSelectedCustomer}/>*/}

        <Dialog
            open={isPrintAlertOpen}
            onClose={() => setIsPrintAlertOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
        >
            <DialogTitle id="alert-dialog-title">
                <div>{t("Print ")}</div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <MDTypography variant="h6" color="text">The warehousing receipt print information is currently being prepared. Please try again in 1 minute. </MDTypography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton variant={'outlined'} color="primary" onClick={() => setIsPrintAlertOpen(false)}>Close</MDButton>
            </DialogActions>
        </Dialog>

        <Dialog
            open={deleteOpen}
            onClose={handleClose}
            PaperProps={{
                component: 'form',
            }}
        >
            <DialogTitle>{t('InboundPage.Cancel Confirmation')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('InboundPage.To Cancel the Inbound, please enter the cancel reason here to move to step.')}
                </DialogContentText>
                <TextField
                    autoFocus
                    required
                    autoComplete='off'
                    margin="dense"
                    id="cancelReason"
                    name="cancelReason"
                    label={t("InboundPage.Cancel Reason")}
                    type="cancelReason"
                    fullWidth
                    variant="standard"
                    value={cancelReason}
                    onChange={(e)=>setCancelReason(e.target.value)}
                />
                <FormHelperText id="outlined-helper-text"> {t('InboundPage.between 5 to 20 characters')}</FormHelperText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{t('Cancel')}</Button>
                <Button onClick={handleDeleteSubmit}>{t('Confirm')}</Button>
            </DialogActions>
        </Dialog>





        <Dialog
            open={isDeleteAlertOpen}
            onClose={(event, reason) => {
                if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    setIsDeleteAlertOpen(false)
                }
            }}
            // onClose={() => {
            //     setIsAlertOpen(false)
            // }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
        >
            <DialogTitle id="alert-dialog-title">
                <div>{t("Are you sure?")}</div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {`${t('InboundPage.Do you really want to delete ASN No.')}`}:
                    <span style={{ color: 'red', padding: '10px', fontWeight: 'bold' }}>{previewData?.warehousing?.applyAsnNo}</span>
                    ? {t('This process cannot be undone')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton disabled={deleteLoading} onClick={() => setIsDeleteAlertOpen(false)}>Disagree</MDButton>
                <LoadingButton
                    onClick={onDeleteSubmit}
                    loading={deleteLoading}
                    sx={{color:"red","&:hover": {
                            color: "red"
                        }}}
                    loadingIndicator={
                        <CircularProgress size={18} sx={{ color: 'red' }} />
                    }
                >
                    Agree
                </LoadingButton>
                {/*<MDButton onClick={onSubmit} autoFocus sx={{ color: 'red' }} variant='outlined'>*/}
                {/*    Agree*/}
                {/*</MDButton>*/}
            </DialogActions>
        </Dialog>

        {/* warehouse弹窗部分 */}
        <Dialog open={warehouseDialogOpen} onClose={() => setWarehouseDialogOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>{t("InboundPage.Find a Ship to Warehouse")}</DialogTitle>
            <DialogContent dividers>
                {/* 国家筛选 */}
                <Autocomplete
                    options={[...new Set(inboundWarehouseList?.map((ele) => ele.countryCode))] || []}
                    value={warehouseCountry}
                    onChange={(e, val) => {
                        setWarehouseCountry(val);
                        setWarehouseProvince('');
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t("InboundPage.Country")}
                            margin="dense"
                            autoComplete="new-password"
                            name={`ignore-autofill-${Math.random().toString(36).substring(2, 10)}`} // 生成随机 name
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: 'new-password',
                                name: `ignore-autofill-inner-${Math.random().toString(36).substring(2, 10)}`
                            }}
                        />
                    )}
                />

                {/* 省份筛选 */}
                <Autocomplete
                    options={provinceOption}
                    value={warehouseProvince}
                    onChange={(e, val) => {
                        setWarehouseProvince(val)
                    }}
                    renderInput={(params) =>
                        <TextField {...params}
                                   label={t("InboundPage.Province")}
                                   margin="dense"
                                   name={`ignore-autofill-${Math.random().toString(36).substring(2, 10)}`} // 生成随机 name
                                   inputProps={{
                                       ...params.inputProps,
                                       autoComplete: 'new-password',
                                       name: `ignore-autofill-inner-${Math.random().toString(36).substring(2, 10)}`
                                   }}
                                   autoComplete="new-password"
                        />
                }
                />

                <TextField
                    fullWidth
                    placeholder={t("InboundPage.City")}
                    value={warehouseCity}
                    onChange={(e) => {
                        setWarehouseCity(e.target.value);
                    }}
                    margin="normal"
                    name={`ignore-autofill-${Math.random().toString(36).substring(2, 10)}`} // 生成随机 name
                    inputProps={{
                        autoComplete: 'new-password',
                        name: `ignore-autofill-inner-${Math.random().toString(36).substring(2, 10)}`
                    }}
                    autoComplete="new-password"
                />

                <TextField
                    fullWidth
                    placeholder={t("InboundPage.Postcode")}
                    value={warehousePostcode}
                    onChange={(e) => {
                        setWarehousePostcode(e.target.value);
                    }}
                    margin="normal"
                    name={`ignore-autofill-${Math.random().toString(36).substring(2, 10)}`} // 生成随机 name
                    inputProps={{
                        autoComplete: 'new-password',
                        name: `ignore-autofill-inner-${Math.random().toString(36).substring(2, 10)}`
                    }}
                    autoComplete="new-password"
                />

                <TextField
                    fullWidth
                    placeholder={t("InboundPage.Warehouse Name")}
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value);
                    }}
                    margin="normal"
                    name={`ignore-autofill-${Math.random().toString(36).substring(2, 10)}`} // 生成随机 name
                    inputProps={{
                        autoComplete: 'new-password',
                        name: `ignore-autofill-inner-${Math.random().toString(36).substring(2, 10)}`
                    }}
                    autoComplete="new-password"
                />
                {(!!warehouseCountry ||!!warehousePostcode || !!warehouseCity || !!search)
                    &&
                    <List dense>

                        {
                            // filteredList
                            inboundWarehouseList.map((ele)=> {
                                return(
                                    {...ele,...warehouseList.find((e) => e.dictValue === ele.warehouseId)}
                                )
                            }).filter(
                                (ele)=> (!warehouseCountry || ele.countryCode === warehouseCountry)
                                && (!warehouseProvince || ele.provinceCode === warehouseProvince)
                                && ele.city?.toLowerCase().includes(warehouseCity?.toLowerCase())
                                && ele.dictLabel?.toLowerCase().includes(search?.toLowerCase())
                                && ele.postcode?.toLowerCase().includes(warehousePostcode?.toLowerCase())
                            )
                            .map((item) => (
                            <ListItemButton
                                key={item.dictValue}
                                selected={selectedInDialog?.dictValue === item.dictValue}
                                onClick={() => setSelectedInDialog(item)}
                            >
                                <ListItemText
                                    primary={
                                        <>
                                            <strong>{item.dictLabel}</strong>
                                            <br />
                                            {item.city}, {item.province}, {item.postcode}, {item.country}
                                            <br />

                                        </>
                                    }
                                />
                            </ListItemButton>
                        ))}
                    </List>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setWarehouseDialogOpen(false)}>{t("Cancel")}</Button>
                <Button onClick={handleConfirm} variant="contained">{t("Confirm")}</Button>
            </DialogActions>
        </Dialog>


    </React.Fragment>)
}

export default InboundsEditor